import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { FormControl, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../animations/page-transitions';
import { DatacenterType, UserDatacenterView } from '../../models/datacenter-aggrid-view';
import { DatacenterViewService } from '../../services/datacenter-view.service';

function duplicateNameValidator(views: UserDatacenterView[]): ValidatorFn {
	return control => {
		const controlValue = typeof control.value === 'string' ? control.value.trim() : '';
		if (!controlValue) {
			return null;
		}

		const lowerCaseControlValue = controlValue.toLowerCase();
		const isContains = views.some(value =>
			value.name.trim().toLowerCase() === lowerCaseControlValue);
		return isContains ? { duplicateName: true } : null;
	};
}

export interface SaveViewDialogData {
	name?: string | undefined;
	datacenterType: DatacenterType;
}

@Component({
	selector: 'copo-datacenter-save-view',
	templateUrl: './datacenter-save-view-dialog.component.html',
	styleUrl: './datacenter-save-view-dialog.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,

		MatButtonModule,

		MatDialogModule,
		MatIconModule,
		TranslateModule,

		MatFormFieldModule,

		MatInputModule,
		FormsModule,
		ReactiveFormsModule
	]
})
export class DatacenterSaveViewDialogComponent {
	name: string | undefined;
	datacenterType: DatacenterType;

	newName: FormControl;

	constructor(
		private readonly viewService: DatacenterViewService,

		private readonly dialogRef: MatDialogRef<DatacenterSaveViewDialogComponent>,

		@Inject(MAT_DIALOG_DATA) public data: SaveViewDialogData,
	) {
		this.name = this.data.name;
		this.datacenterType = this.data.datacenterType;
		this.newName = new FormControl(
			'',
			[
				Validators.required,
				duplicateNameValidator(this.viewService.getViewList(this.datacenterType))
			]
		);
	}

	onCancelClick() {
		this.dialogRef.close();
	}
}
